import { render, staticRenderFns } from "./CulvertView.vue?vue&type=template&id=147694e1&scoped=true"
import script from "./CulvertView.vue?vue&type=script&lang=ts"
export * from "./CulvertView.vue?vue&type=script&lang=ts"
import style0 from "./CulvertView.vue?vue&type=style&index=0&id=147694e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147694e1",
  null
  
)

export default component.exports